import '/app/brewery-packages/content/content-editor-plugin-list-item/src/ListItem.css-raw';
export default {
  "listItem": "jobs-2ec46bc8-listItem-zUCuRq"
};